import { render, staticRenderFns } from "./ConsultoriaCard.vue?vue&type=template&id=48d26ccd&scoped=true&"
import script from "./ConsultoriaCard.vue?vue&type=script&lang=js&"
export * from "./ConsultoriaCard.vue?vue&type=script&lang=js&"
import style0 from "./ConsultoriaCard.vue?vue&type=style&index=0&id=48d26ccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d26ccd",
  null
  
)

export default component.exports